export default "__VITE_ASSET__ofbVTddP__"